export default "__VITE_ASSET__Bqsf2vMu__"